/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const PriceTag = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 16 15" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M15 4.3c-.1.5-.1 1.2-.2 1.7 0 0-.2.8-.8 1.4l-7.3 7.3s-.7.7-1.3-.1l-5-5C-.3 8.9.3 8.3.3 8.3L7.6 1C8.2.5 9 .3 9 .3c.6-.1 1.2-.2 1.7-.2 0 0 2.9-.3 3.5.4l.4.4c.6.5.4 3.4.4 3.4zm-2.9-1.4c-.6-.6-1.6-.6-2.1 0-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0 .6-.6.6-1.5 0-2.1z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

PriceTag.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

PriceTag.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default PriceTag;
